exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".home-content-wrapper[data-v-3cd328f0]{position:relative}.home-content-wrapper[data-v-3cd328f0]:before{content:\"\";position:absolute;top:0;left:0;width:100%;height:100%;background-image:url(/images/background.png);background-repeat:repeat;opacity:.15;z-index:-1;pointer-events:none}", ""]);

// exports
